import type { MemberPublic, Notification, NotificationType } from '@/lib/db/types';

export function notificationCopy(n: Notification, actor?: MemberPublic | null): string {
  const name = actor?.name ?? 'Someone';
  switch (n.type as NotificationType | 'like' | 'mention' | 'wager') {
    case 'reaction':
    case 'like':
      return `${name} reacted to your round`;
    case 'comment':
      return `${name} commented on your round`;
    case 'follow':
      return `${name} followed you`;
    case 'invitation':
      return `${name} invited you to join`;
    case 'game':
      return n.body ?? `${name} added you to a game`;
    case 'wager':
      return n.body ?? 'You have an unsettled wager';
    case 'achievement':
      return n.body ?? 'Achievement unlocked';
    case 'ace':
      return n.body ?? `${name} recorded a hole-in-one`;
    case 'tournament':
      return n.body ?? 'Tournament update';
    case 'system':
      return n.body ?? 'Club update';
    default:
      return n.body ?? n.type.replace(/_/g, ' ');
  }
}
